export default __webpack_public_path__ + "static/media/blank.4008f653.jpg";